import DesktopNav from '@/components/layouts/navigation/DesktopNav';
import MobileNav from '@/components/layouts/navigation/MobileNav';
import React from 'react';

const SidebarApps = () => {
  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex">
        <DesktopNav />
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="md:hidden">
        <MobileNav />
      </div>
    </>
  );
};

export default SidebarApps;
